module.exports = __webpack_public_path__ + "static/logo-no-text.7c47a88b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/logo-no-text.png
// module id = 941
// module chunks = 114276838955818